var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"m-builer"},[_c('img',{ref:"icon",staticClass:"img",attrs:{"src":_vm.src,"alt":_vm.label,"draggable":""},on:{"dragstart":function($event){return _vm.startDrag($event)},"dragend":function($event){return _vm.endDrag($event)}}}),_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }